// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6520) return "static/chunks/e2c5e4d9-fa1035bdf7890e90.js";
	if (chunkId === 1507) return "static/chunks/18050da9-a37b4310c21c6da4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"104":"7066cf3a53b734bb","3576":"5feb98daaf37f1a1"}[chunkId] + ".js";
};